"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type$generateConstructor = exports.Type$generateMethod = exports.getIdFromState = exports.isEntityType = exports.isValueArray = exports.isValue = exports.isValueType = exports.Type = exports.Type$newIdPrefix = void 0;
var entity_1 = require("./entity");
var property_1 = require("./property");
var helpers_1 = require("./helpers");
var events_1 = require("./events");
var observable_array_1 = require("./observable-array");
var rule_1 = require("./rule");
var format_1 = require("./format");
var property_chain_1 = require("./property-chain");
exports.Type$newIdPrefix = "+c";
var Type = /** @class */ (function () {
    // readonly conditionsChanged: EventSubscriber<Type, ConditionTargetsChangedEventArgs>;
    function Type(model, fullName, baseType, format, options) {
        if (baseType === void 0) { baseType = null; }
        this.model = model;
        this.fullName = fullName;
        this.jstype = Type$generateConstructor(this, fullName, baseType, model.settings.useGlobalObject ? helpers_1.getGlobalObject() : null);
        this.baseType = baseType;
        this.derivedTypes = [];
        this._identifier = null;
        this._abstract = false;
        Object.defineProperty(this, "__pool__", { enumerable: false, configurable: false, writable: false, value: {} });
        Object.defineProperty(this, "__properties__", { enumerable: false, configurable: false, writable: false, value: {} });
        Object.defineProperty(this, "_lastId", { enumerable: false, configurable: false, writable: true, value: 0 });
        Object.defineProperty(this, "_formats", { enumerable: false, configurable: false, writable: true, value: {} });
        Object.defineProperty(this, "_chains", { enumerable: false, configurable: false, writable: true, value: {} });
        if (baseType) {
            baseType.derivedTypes.push(this);
        }
        this.initNew = new events_1.Event();
        this.initExisting = new events_1.Event();
        // this.conditionsChanged = new Event<Type, ConditionTargetsChangedEventArgs>();
        // Set Format
        if (format) {
            if (typeof (format) === "string") {
                this.format = this.model.getFormat(this.jstype, format);
            }
            else
                this.format = format;
        }
        // Apply type options
        if (options)
            this.extend(options);
    }
    Object.defineProperty(Type.prototype, "identifier", {
        get: function () {
            if (this._identifier)
                return this._identifier;
            return this.baseType ? this.baseType.identifier : null;
        },
        set: function (val) {
            this._identifier = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Type.prototype, "isAbstract", {
        get: function () {
            return this._abstract;
        },
        set: function (val) {
            this._abstract = val;
        },
        enumerable: false,
        configurable: true
    });
    Type.prototype.createIfNotExists = function (state) {
        var id = getIdFromState(this, state);
        if (id) {
            var existing = this.get(id);
            if (existing)
                return existing;
        }
        var Ctor = this.jstype;
        // Construct an instance using the known id if it is present
        var instance = (id ? new Ctor(id, state) : new Ctor(state));
        return instance;
    };
    Type.prototype.createSync = function (state) {
        var id = getIdFromState(this, state);
        if (id && this.get(id))
            throw new Error("Could not create instance of type '" + this.fullName + "' with identifier '" + id + "' because this object already exists.");
        var Ctor = this.jstype;
        // Construct an instance using the known id if it is present
        var instance = (id ? new Ctor(id, state) : new Ctor(state));
        return instance;
    };
    Type.prototype.create = function (state) {
        var instance = this.createSync(state);
        return instance.initialized.then(function () { return instance; });
    };
    /** Generates a unique id suitable for an instance in the current type hierarchy. */
    Type.prototype.newId = function () {
        var lastId;
        for (var type = this; type; type = type.baseType) {
            lastId = Math.max(lastId || 0, type._lastId);
        }
        var nextId = lastId + 1;
        // Update the last id for each type in the heirarchy.
        for (var type = this; type; type = type.baseType) {
            type._lastId = nextId;
        }
        // Return the new id.
        return exports.Type$newIdPrefix + nextId;
    };
    Type.prototype.assertValidId = function (id) {
        if (id === null || id === undefined) {
            throw new Error("Id cannot be " + (id === null ? "null" : "undefined") + " (entity = " + this.fullName + ").");
        }
        else if (helpers_1.getTypeName(id) !== "string") {
            throw new Error("Id must be a string:  encountered id " + id + " of type \"" + helpers_1.parseFunctionName(id.constructor) + "\" (entity = " + this.fullName + ").");
        }
        else if (id === "") {
            throw new Error("Id cannot be a blank string (entity = " + this.fullName + ").");
        }
    };
    Type.prototype.unregister = function (obj) {
        this.assertValidId(obj.meta.id);
        for (var t = this; t; t = t.baseType) {
            var key = t.poolKey(obj.meta.id, obj);
            delete t.__pool__[key];
            if (t.__known__) {
                var index = t.__known__.indexOf(obj);
                if (index >= 0)
                    t.__known__.splice(index, 1);
            }
        }
    };
    Type.prototype.register = function (obj) {
        this.assertValidId(obj.meta.id);
        for (var t = this; t; t = t.baseType) {
            var key = t.poolKey(obj.meta.id, obj);
            if (t.__pool__.hasOwnProperty(key)) {
                throw new Error("Object \"" + this.fullName + "|" + obj.meta.id + "\" has already been registered.");
            }
            t.__pool__[key] = obj;
            if (t.__known__) {
                t.__known__.push(obj);
            }
        }
        if (this.model.settings.createOwnProperties === true) {
            for (var prop in this.__properties__) {
                if (Object.prototype.hasOwnProperty.call(this.__properties__, prop)) {
                    var property = this.__properties__[prop];
                    property_1.Property$generateOwnProperty(property, obj);
                }
            }
        }
        this.model.entityRegistered.publish(this.model, { entity: obj });
    };
    Type.prototype.poolKey = function (id, obj) {
        return this.isAbstract ? obj.meta.type.fullName + "|" + id.toLowerCase() : id.toLowerCase();
    };
    Type.prototype.changeObjectId = function (obj, newId) {
        this.assertValidId(obj.meta.id);
        this.assertValidId(newId);
        var oldKey = this.poolKey(obj.meta.id, obj);
        var newKey = this.poolKey(newId, obj);
        if (this.__pool__[newKey]) {
            throw new Error("Entity '" + this.fullName + "|" + newKey + "' is already registered.");
        }
        var cached = this.__pool__[oldKey];
        if (!cached) {
            // TODO: Throw error or warn when attempting to change an object Id that is unknown?
            return;
        }
        for (var t = this; t; t = t.baseType) {
            t.__pool__[t.poolKey(newId, obj)] = obj;
        }
        obj.meta.id = newId;
        obj.markPersisted();
        return obj;
    };
    Type.prototype.get = function (id, exactTypeOnly) {
        if (exactTypeOnly === void 0) { exactTypeOnly = false; }
        if (!id) {
            throw new Error("Method \"" + this.fullName + ".meta.get()\" was called without a valid id argument.");
        }
        if (this.isAbstract) {
            throw new Error("Method \"" + this.fullName + ".meta.get()\" cannot be called because the type is abstract.");
        }
        var key = id.toLowerCase();
        var obj = this.__pool__[key];
        // If exactTypeOnly is specified, don't return sub-types.
        if (obj && exactTypeOnly === true && obj.meta.type !== this) {
            throw new Error("The entity with id='" + id + "' is expected to be of type '" + this.fullName + "' but found type '" + obj.meta.type.fullName + "'.");
        }
        return obj;
    };
    // Gets an array of all objects of this type that have been registered.
    // The returned array is observable and collection changed events will be raised
    // when new objects are registered.
    // The array is in no particular order.
    Type.prototype.known = function () {
        var known = this.__known__;
        if (!known) {
            var list = [];
            for (var id in this.__pool__) {
                if (Object.prototype.hasOwnProperty.call(this.__pool__, id)) {
                    list.push(this.__pool__[id]);
                }
            }
            known = observable_array_1.ObservableArray.ensureObservable(list);
            Object.defineProperty(this, "__known__", { enumerable: false, configurable: false, writable: false, value: known });
        }
        return known;
    };
    Type.prototype.getProperty = function (name) {
        var prop;
        for (var t = this; t && !prop; t = t.baseType) {
            prop = t.__properties__[name];
            if (prop) {
                return prop;
            }
        }
        return null;
    };
    /** Gets the {Property} or {PropertyChain} for the specified simple path {string}. */
    Type.prototype.getPath = function (path) {
        // Get single property
        var property = this.getProperty(path);
        // Get cached property chain
        if (!property)
            property = this._chains[path];
        // Create and cache property chain
        if (!property) {
            property = this._chains[path] = new property_chain_1.PropertyChain(this, path);
        }
        // Return the property path
        return property;
    };
    /** Gets and array of {Property} or {PropertyChain} instances for the specified complex graph path {string}. */
    Type.prototype.getPaths = function (path) {
        var start = 0;
        var paths = [];
        // Process the path
        if (/{|,|}/g.test(path)) {
            var stack = [];
            var parent_1;
            for (var i = 0, len = path.length; i < len; ++i) {
                var c = path.charAt(i);
                if (c === "{" || c === "," || c === "}") {
                    var seg = path.substring(start, i).trim();
                    start = i + 1;
                    if (c === "{") {
                        if (parent_1) {
                            stack.push(parent_1);
                            parent_1 += "." + seg;
                        }
                        else {
                            parent_1 = seg;
                        }
                    }
                    else { // ',' or '}'
                        if (seg.length > 0) {
                            paths.push(this.getPath(parent_1 ? parent_1 + "." + seg : seg));
                        }
                        if (c === "}") {
                            parent_1 = (stack.length === 0) ? undefined : stack.pop();
                        }
                    }
                }
            }
            if (stack.length > 0 || parent_1) {
                throw new Error("Unclosed '{' in path: " + path);
            }
            if (start < path.length) {
                var seg = path.substring(start).trim();
                if (seg.length > 0) {
                    paths.push(this.getPath(seg));
                }
                // Set start to past the end of the list to indicate that the entire string was processed
                start = path.length;
            }
        }
        // If the input is a simple property or path, then add the single property or chain
        if (start === 0) {
            paths.push(this.getPath(path.trim()));
        }
        return paths;
    };
    Object.defineProperty(Type.prototype, "properties", {
        get: function () {
            var propertiesObject = __assign({}, this.__properties__);
            for (var type = this.baseType; type != null; type = type.baseType) {
                for (var propertyName in type.__properties__) {
                    if (!propertiesObject.hasOwnProperty(propertyName)) {
                        propertiesObject[propertyName] = type.__properties__[propertyName];
                    }
                }
            }
            return Object.values(propertiesObject);
        },
        enumerable: false,
        configurable: true
    });
    Type.prototype.addRule = function (optionsOrFunction) {
        var options;
        if (optionsOrFunction) {
            // The options are the function to execute
            if (optionsOrFunction instanceof Function) {
                options = { execute: optionsOrFunction };
            }
            else {
                options = optionsOrFunction;
            }
        }
        var rule = new rule_1.Rule(this, options.name, options);
        // TODO: Track rules on the type?
        return rule;
    };
    Type.prototype.hasModelProperty = function (prop) {
        return prop.containingType === this || this.isSubclassOf(prop.containingType);
    };
    Type.prototype.isSubclassOf = function (type) {
        var result = false;
        helpers_1.navigateAttribute(this, "baseType", function (baseType) {
            if (baseType === type) {
                result = true;
                return false;
            }
        });
        return result;
    };
    Type.prototype.toString = function () {
        return this.fullName;
    };
    /**
     * Extends the current type with the specified format, properties and methods
     * @param options The options specifying how to extend the type
     */
    Type.prototype.extend = function (options) {
        var _this = this;
        var type = this;
        // Utility function to convert a path string into a resolved array of Property and PropertyChain instances
        function resolveDependsOn(rule, dependsOn) {
            // return an empty dependency array if no path was specified
            if (!dependsOn)
                return [];
            // throw an exception if dependsOn is not a string
            if (typeof (dependsOn) !== "string")
                throw new Error("Invalid dependsOn property for '" + rule + "' rule on '" + type + ".");
            // get the property paths for the specified dependency string
            return type.getPaths(dependsOn);
        }
        // Use prepare() to defer property path resolution while the model is being extended
        this.model.prepare(function () {
            var isRuleMethod = function (value) { return value.hasOwnProperty("function"); };
            var _loop_1 = function (name_1, member) {
                if (name_1.startsWith("$"))
                    return "continue";
                // Ignore Type and Format values, which do not represent type members
                if (member instanceof Type || member instanceof format_1.Format)
                    return "continue";
                // Property Type Name
                if (typeof (member) === "string")
                    member = { type: member };
                // Property Type
                else if (isValueType(member))
                    member = { type: member };
                // Non-Rule Method/Function
                if (typeof (member) === "function") {
                    Type$generateMethod(_this, _this.jstype.prototype, name_1, member);
                }
                // Rule Method
                else if (isRuleMethod(member)) {
                    var func = member.function, dependsOn_1 = member.dependsOn;
                    Type$generateMethod(_this, _this.jstype.prototype, name_1, func);
                    _this.model.ready(function () {
                        new rule_1.Rule(_this, _this.fullName + "." + name_1 + "Rule", {
                            execute: (function () { this[name_1](); }),
                            onChangeOf: resolveDependsOn("get", dependsOn_1)
                        }).register();
                    });
                }
                // Property
                else {
                    member = __assign({}, member);
                    // Get Property
                    var property = _this.getProperty(name_1);
                    // Add Property
                    if (!property
                        || (member.type && isEntityType(property.propertyType) && property.propertyType.meta.fullName !== member.type)
                        || (member.type && isValueType(member.type) && isValueType(property.propertyType) && property.propertyType !== member.type)) {
                        // Type & IsList
                        var isList = false;
                        if (typeof (member.type) === "string") {
                            var typeName = member.type;
                            // Type names ending in [] are lists
                            if (typeName.lastIndexOf("[]") === (typeName.length - 2)) {
                                isList = true;
                                typeName = typeName.substr(0, typeName.length - 2);
                            }
                            // Convert type names to javascript types
                            member.type = _this.model.getJsType(typeName);
                            // Warn if the type couldn't be found
                            if (!member.type && window.console && console.warn) {
                                console.warn("Could not resolve type '" + typeName + ".");
                            }
                        }
                        var isIdentifier = member.identifier === true;
                        // Add Property
                        var property_2 = new property_1.Property(_this, name_1, member.type, isIdentifier, isList, member);
                        if (isIdentifier) {
                            _this.identifier = property_2;
                        }
                        _this.__properties__[name_1] = property_2;
                        property_1.Property$generateShortcuts(property_2, _this.jstype);
                        if (!_this.model.settings.createOwnProperties) {
                            property_1.Property$generatePrototypeProperty(property_2, _this.jstype.prototype);
                        }
                    }
                    else {
                        property.extend(member, _this);
                    }
                }
            };
            // Type Members
            for (var _i = 0, _a = helpers_1.entries(options); _i < _a.length; _i++) {
                var _b = _a[_i], name_1 = _b[0], member = _b[1];
                _loop_1(name_1, member);
            }
        });
    };
    return Type;
}());
exports.Type = Type;
function isValueType(type) {
    return type === String || type === Number || type === Date || type === Boolean;
}
exports.isValueType = isValueType;
function isValue(value, type) {
    if (type === void 0) { type = null; }
    if (value == null)
        return false;
    var valueType = value.constructor;
    if (type != null)
        return valueType === type;
    return isValueType(valueType);
}
exports.isValue = isValue;
function isValueArray(value) {
    if (value == null)
        return false;
    if (!Array.isArray(value))
        return false;
    if (value.length === 0)
        return true;
    var item = value[0];
    if (item == null)
        return false;
    var itemType = item.constructor;
    return isValueType(itemType);
}
exports.isValueArray = isValueArray;
function isEntityType(type) {
    return type.meta && type.meta instanceof Type;
}
exports.isEntityType = isEntityType;
function getIdFromState(type, state) {
    if (type.identifier && typeof state === "object") {
        var id = state[type.identifier.name];
        if (id && typeof id === "string" && id.length > 0)
            return id;
    }
}
exports.getIdFromState = getIdFromState;
function Type$generateMethod(type, target, name, fn) {
    target[name] = fn;
}
exports.Type$generateMethod = Type$generateMethod;
// TODO: Get rid of disableConstruction?
var disableConstruction = false;
function Type$generateConstructor(type, fullName, baseType, global) {
    if (baseType === void 0) { baseType = null; }
    if (global === void 0) { global = null; }
    // Create namespaces as needed
    var nameTokens = fullName.split(".");
    var token = nameTokens.shift();
    var namespaceObj = type.model.$namespace || type.model;
    var namespacePrefix = "";
    var globalObj = global;
    while (nameTokens.length > 0) {
        namespacePrefix = namespacePrefix + token + ".";
        namespaceObj = helpers_1.ensureNamespace(token, namespaceObj);
        if (global) {
            globalObj = helpers_1.ensureNamespace(token, globalObj);
        }
        token = nameTokens.shift();
    }
    // The final name to use is the last token
    var finalName = token;
    var BaseConstructor;
    if (baseType) {
        BaseConstructor = baseType.jstype;
        // // TODO: Implement `inheritBaseTypePropShortcuts`
        // // inherit all shortcut properties that have aleady been defined
        // inheritBaseTypePropShortcuts(ctor, baseType);
    }
    else {
        BaseConstructor = entity_1.Entity;
    }
    function construct() {
        if (!disableConstruction) {
            try {
                entity_1.Entity.ctorDepth++;
                var args = Array.from(arguments);
                if (!(args[0] instanceof Type))
                    args.unshift(type);
                BaseConstructor.apply(this, args);
            }
            finally {
                entity_1.Entity.ctorDepth--;
            }
        }
    }
    var ctor = (function () {
        construct.apply(this, arguments);
    });
    Object.defineProperty(ctor, "name", { value: finalName, configurable: true });
    var namespaceKey = finalName;
    // If the namespace already contains a type with this name, prepend a '$' to the name
    while (namespaceObj[namespaceKey]) {
        if (process.env.NODE_ENV === "development") {
            console.warn("Namespace path '" + namespacePrefix + namespaceKey + "' is already assigned.");
        }
        namespaceKey = "$" + namespaceKey;
    }
    namespaceObj[namespaceKey] = ctor;
    if (global) {
        var globalKey = finalName;
        // If the global object already contains a type with this name, append a '$' to the name
        while (globalObj[globalKey]) {
            if (process.env.NODE_ENV === "development") {
                console.warn("Global path '" + namespacePrefix + globalKey + "' is already assigned.");
            }
            globalKey = "$" + globalKey;
        }
        globalObj[globalKey] = ctor;
    }
    // Setup inheritance
    disableConstruction = true;
    ctor.prototype = new BaseConstructor();
    disableConstruction = false;
    ctor.prototype.constructor = ctor;
    // Add the 'meta' helper
    Object.defineProperty(ctor, "meta", { enumerable: false, value: type, configurable: false, writable: false });
    return ctor;
}
exports.Type$generateConstructor = Type$generateConstructor;
